import * as angular from "angular";
import { CampaignDataProvider } from "../../data-provider/campaign.dp";
import { SubscriptionDataProvider } from "../../data-provider/subscription.dp";
import { Campaign } from "../../models/campaign.model";

let EssentialsPromoComponent = {
    selector: "vcEssentialsPromo",
    templateUrl:
        "/angular/components/essentials/essentials-promo.component.html",
    bindings: {
        country: "&?",
        noun: "=?",
        confirmation: "=",
        dismissedPromo: "=?",
        openEssentialsFn: "&?",
        selectedInterval: "=?",
    },
    controller: class EssentialsPromoController {
        // * bindings for typescript compiler *
        public country?: any;
        public noun?: any;
        public confirmation: any;
        public dismissedPromo?: any;
        public openEssentialsFn?: any;
        public selectedInterval?: any;
        // ************************************

        private $window: any;
        private campaignDataProvider: CampaignDataProvider;
        private subscriptionDataProvider: SubscriptionDataProvider;

        public __env: any;
        public plans: object[] = [];
        public plan: object;
        public campaign: Campaign;
        public toggle: object;
        public iconType: string;

        constructor(
            $window: any,
            __env: any,
            CampaignDataProvider: CampaignDataProvider,
            SubscriptionDataProvider: SubscriptionDataProvider
        ) {
            this.$window = $window;
            this.__env = __env;
            this.campaignDataProvider = CampaignDataProvider;
            this.subscriptionDataProvider = SubscriptionDataProvider;

            this.campaign = this.campaignDataProvider.getActiveCampaign();
            this.toggle = {
                yearly: this.__env.product_name === "Ecanvasser",
            };
        }

        $onInit(): void {
            this.iconType = this.confirmation ? "check_circle" : "check";

            this.subscriptionDataProvider
                .getPlans(this.campaign.campaignid, false)
                .then((plans: any[]) => {
                    this.plans = plans
                        .filter((plan: any) => {
                            return (
                                plan.cpname.indexOf("Legacy") !== -1 ||
                                plan.cpname.indexOf("Essentials") !== -1
                            );
                        })
                        .map((plan: any) => {
                            plan.freq =
                                plan.cpinterval == "Monthly" ? "mo" : "yr";
                            return plan;
                        });

                    this.setPlan(this.selectedInterval);
                });
        }

        setPlan(interval?: string): void {
            this.plan = this.plans[!interval || interval == "Monthly" ? 0 : 1];
        }

        openIntercomChat(): void {
            this.$window.Intercom("showNewMessage");
        }
    },
};

angular
    .module("essentials", [])
    .component(EssentialsPromoComponent.selector, EssentialsPromoComponent);
